export enum RegistrationType {
  CANDIDATURE = 'CANDIDATURE',
  INVITATION = 'INVITATION',
  SELECTION = 'SELECTION',
}
